export const locale = {
    'CUSTOMER_ORDER': {
        'DIALOG': {
            'CREATE' : {
                'TITLE': {
                    'CREATE': 'Create proposal',
                    'EDIT': 'Edit proposal',
                },
                'CONFIRMBUTTON': {
                    'CREATE': 'Create',
                    'SAVE': 'SAVE',
                },
                'CONTROLS': {
                    'SUPPLIER_SELECTOR': 'Supplier',
                    'BRAND_SELECTOR': 'Brand',
                    'TYPE_SELECTOR': 'Type',
                    'UNLOADING_DATE': 'Unloading date',
                    'UNLOADING_TIME_FROM': 'Time from',
                    'UNLOADING_TIME_TO': 'to',
                    'TONNAGE': 'Tonnage',
                    'COUNT': 'Count',
                    'UNLOADING_ADDRESS_SELECTOR': 'Unloading address',
                    'COMMENT': 'Comment',
                },
                'ERROR': {
                    'SAVE_ERROR': 'Failed to update order. Try again later or contact your manager.',
                    'LOAD_ERROR': 'Load error',
                    'MUST_SELECT': 'You need to select item from list',
                    'UNDEFINED': 'Failed to make order. Try again later or contact your manager.',
                    'NoSupplierForArticle': 'Product is not for sale',
                },
            },
        },
    },
};
